import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { PlanState } from '../graphql/generated/gen-types';

@Injectable({
	providedIn: 'root'
})
export class SubscriptionStateService {
	private planStateSubject = new BehaviorSubject<PlanState>(PlanState.Active);
	private isBlockedSubject = new BehaviorSubject<boolean>(false);

	readonly planState$: Observable<PlanState> = this.planStateSubject.asObservable();
	readonly isBlocked$: Observable<boolean> = this.isBlockedSubject.asObservable();

	updateState(planState: PlanState): void {
		this.planStateSubject.next(planState);
	}

	updateBlockedState(isBlocked: boolean): void {
		this.isBlockedSubject.next(isBlocked);
	}
}
